import { render } from 'views/client';
import View from '.';

render(View);




// WEBPACK FOOTER //
// ./src/views/play-cricket-mvps/play-cricket-mvps.js